import gql from 'graphql-tag'

import { contentFeedItemFragment, IContentFeedItem } from './getContentFeeds'

export interface IContentFeedBoostCandidate {
  itemType: string
  itemId: string
  item: IContentFeedItem | null
  taggedAt: string | null
  /** The topic whose tag surfaced this candidate; null for recency results. */
  matchedTopic: { id: string; name: string } | null
  /**
   * False means the item shows only while boosted and vanishes when unboosted,
   * rather than falling into the feed's chronological tail.
   */
  inFeedTopics: boolean | null
}

export interface IContentFeedBoostCandidatesResponse {
  contentFeedBoostCandidates: IContentFeedBoostCandidate[]
}

/**
 * Items eligible to be boosted into a feed. The server already excludes items
 * currently boosted in the feed, so the modal re-adds them itself to show them
 * as "Added" rather than leaving a curator wondering where they went.
 */
export const CANDIDATE_PAGE_SIZE = 25

export const contentFeedBoostCandidatesQuery = gql`
  query contentFeedBoostCandidates(
    $contentFeedId: String
    $topicIds: [String!]
    $types: [ContentFeedItemType!]
    $query: String
    $offset: Int
    $size: Int
  ) {
    contentFeedBoostCandidates(
      contentFeedId: $contentFeedId
      topicIds: $topicIds
      types: $types
      query: $query
      offset: $offset
      size: $size
    ) {
      itemType
      itemId
      taggedAt
      inFeedTopics
      matchedTopic {
        id
        name
      }
      item {
        ...ContentFeedItemFields
      }
    }
  }
  ${contentFeedItemFragment}
`

export default contentFeedBoostCandidatesQuery
